import React, { useState, useEffect } from "react";
import { Avatar, Grid } from "@mui/material";
import axios from "axios";
import { baseURL } from "../../api";
import { Global_Data } from "../../globalData/GlobalData";
import { Icon } from "../../utils/MuiIcons/Icon";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";

function AvatarComponent({ data }) {
  const { token } = Global_Data();
  const [imgSrc, setImgSrc] = useState(null);
  const [imgError, setImgError] = useState(false);
  const [urlImageLoading, setUrlImageLoading] = useState(false);
  const { loading, trackRequest } = usePendingRequests();

  const sOption = data?.component?.sOption;
  const sAction = data?.data?.sAction;
  const sDataSource = data?.data?.sDataSource;
  const sLabel = data?.component?.sLabel || data?.component?.sDefaultValue || "";
  const initials = sLabel.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
  const sIcon = data?.component?.sIcon;
  const gridProps = data?.grid_props || {};

  // sProps.sx contains the MUI sx styles (width, height, bgcolor, etc.)
  const sx = data?.component?.sProps?.sx || {};

  const isImageOption = sOption?.toLowerCase() === "image";
  const isIconOption = sOption?.toLowerCase() === "icon";

  useEffect(() => {
    if (isImageOption && sAction === "URL" && sDataSource) {
      setUrlImageLoading(true);
      setImgError(false);
    }

    if (isImageOption && sAction === "DEFAULT" && sDataSource && token) {
      setImgSrc(null);
      setImgError(false);
      trackRequest(() =>
        axios.get(`${baseURL}${sDataSource}`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob"
        })
      )
        .then(res => {
          setImgSrc(URL.createObjectURL(res.data));
        })
        .catch(() => setImgError(true));
    }
  }, [sDataSource, sAction, token]);

  const renderAvatar = () => {
    // Image – DEFAULT: fetch via API with auth
    if (isImageOption && sAction === "DEFAULT") {
      if (imgSrc) {
        return <Avatar src={imgSrc} sx={sx} />;
      }
      return <Avatar sx={sx}>{initials}</Avatar>;
    }

    // Image – URL: use sDataSource directly as src
    if (isImageOption && sAction === "URL") {
      return (
        <Avatar
          src={imgError ? undefined : sDataSource}
          sx={sx}
          imgProps={{
            onLoad: () => setUrlImageLoading(false),
            onError: () => {
              setUrlImageLoading(false);
              setImgError(true);
            }
          }}
        >
          {imgError ? initials : null}
        </Avatar>
      );
    }

    // Icon
    if (isIconOption) {
      const iconName = sIcon?.endsWith("Icon") ? sIcon.slice(0, -4) : sIcon;
      return (
        <Avatar sx={sx}>
          <Icon iconName={iconName} />
        </Avatar>
      );
    }

    // Text – show initials for single word, full label for multi-word display
    return <Avatar sx={sx}>{initials || sLabel}</Avatar>;
  };

  return (
    <Grid item {...gridProps}>
      <ComponentLoadingBoundary
        loading={loading || urlImageLoading}
        label={`Loading ${sLabel || data?.component?.sName}`}
        minHeight={sx?.height || 40}
        size={20}
      >
        {renderAvatar()}
      </ComponentLoadingBoundary>
    </Grid>
  );
}

export default AvatarComponent;
